<template>
  <div class="card">
    <div class="left">
      <div class="left-top">
        <slot name="leftTop"></slot>
      </div>
      <div class="left-bottom">
        <slot name="leftBottom"></slot>
      </div>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang="less">
.card{
  width: 96%;
  height: 168px;
  margin: 0 auto;
  background: #fff;
  padding: 0 24px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 16px;
  font-family: Alibaba PuHuiTi;
  align-items: center;
  display: flex;
  .left{
    width: 60%;
    .left-top{
      font-size: 26px;
      color: rgba(31, 36, 51, 1);
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 28px;
    }
  }
  .right{
    width: 40%;
    text-align: right;
    font-size: 40px;
    font-weight: bold;
    font-family: Roboto;
  }
}
</style>
